<template>
    <div class="asset-new">
        <Header></Header>
        <div class="asset-body">
            <div class="asset-body-info">
                <!-- <div class="info-title">
                    <div class="info-title-left">
                        <span><h4>权益</h4></span>
                    </div>
                    <div class="info-title-right">
                        <button>图表</button>
                    </div>
                </div> -->
                <div class="info-static-total">
                    <span>API数量：4</span>
                    <span>总金额(USDT)：2000000</span>
                    <span>已持仓：20000/50000</span>
                </div>
                <div class="info-box">
                    <div class="api-info-content" v-for="(item, index) in apiInfoData" :key="'api-'+index">
                        <div class="api-info-title">
                            <h4>caomi-tantan1-okex</h4><span><strong>5.3</strong> 风险值</span>
                        </div>
                        <div class="api-info-item">
                            <span class="item-col">资产使用：</span>
                            <MyProgressNew class="item-col progress-content" :proressWidth="item.assetUsed" :myWidth="200" :myHeight="15" :widthRight="'20'"></MyProgressNew>
                            <span class="item-col">已开 10000 +抵押 1000/100000</span>
                        </div>
                        <div class="api-info-item">
                            <span class="item-col">仓位比例：</span>
                            <MyProgress class="item-col progress-content" :proressWidth="item.position" :myWidth ="200" :myHeight="15"></MyProgress>
                            <span class="item-col">已开/总可开 10000 /100000</span>
                        </div>
                        <div class="api-info-item">
                            <span class="item-col">借贷风险：</span>
                            <MyProgress class="item-col progress-content" :proressWidth="item.dangerous" :myWidth="200" :myHeight="15"></MyProgress>
                            <span class="item-col">已借/可借 10000/100000</span>
                        </div>
                        <div class="api-info-item">
                            <span class="item-col">风险评级：</span>
                            <!-- <TaskPanel class="item-col progress-content"></TaskPanel> -->
                            <span class="item-col">5.3</span>
                        </div>
                    </div>
                    <div class="test">
                        <span>时间：{{timeNum}}</span>
                        <button @click="stopTimer">暂停</button>
                        <button @click="keepTimer">继续</button>
                        <div class="box">
                            <select id="selectId">
                                <option value="">11</option>
                                <option value="">222222222</option>
                                <option value="">111</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Header from "@/components/header/Header.vue"
import MyProgress from "@/components/My-progress.vue"
import TaskPanel from "@/components/Task-panel.vue"
import MyProgressNew from "@/components/My-progress-new.vue"

export default {
    components: {
        Header,
        MyProgress,
        TaskPanel,
        MyProgressNew
    },
    data: function () {
        return {
            apiInfoData: [
                { 'assetUsed': '60 : 40', 'position': '10 : 90', 'dangerous': '5 : 95', 'dangerLevel': '5 : 95' },
                { 'assetUsed': '60 : 40', 'position': '10 : 90', 'dangerous': '5 : 95', 'dangerLevel': '5 : 95' },
                { 'assetUsed': '60 : 40', 'position': '10 : 90', 'dangerous': '5 : 95', 'dangerLevel': '5 : 95' },
                { 'assetUsed': '60 : 40', 'position': '10 : 90', 'dangerous': '5 : 95', 'dangerLevel': '5 : 95' },
            ],
            timeNum: 0,
            timer: null,
        }
    },
    mounted() {
        this.initTimer() 
    },
    methods: {
        initTimer() {
            this.timer = setInterval(() => {
                this.timeNum ++
            }, 1000)
        },

        stopTimer() {
            clearInterval(this.timer);
        },

        keepTimer() {
            this.timer = setInterval(() => {
                this.timeNum ++
            }, 1000)
        }
    }
}
</script>

<style lang="scss" scoped>
.asset-new {
    #selectId {
        width: auto;
        padding: 0 2%;
        text-align-last: center;
        margin: 0;
        option {
            text-align: center;
        }
    }
    .asset-body {
        // margin-top: 10px;
        color: #a8a7a9;
        display: flex;
        justify-content: space-between;
        padding: 20px;
        .asset-body-api {
            background-color: #2a2d2e;
            flex: 1;
            margin-right: 10px;
            ul {
                li {
                    display: flex;
                    justify-content: space-between;
                    padding: 5px 10px;
                    font-size: 12px;
                }
                li:first-child {
                    display: flex;
                    justify-content: center;
                    background-color: #1e1e1e;
                }
            }
        }
        .asset-body-info {
            flex: 4;
            background-color: #2a2d2e;
            .info-title {
                background-color: #1e1e1e;
                display: flex;
                justify-content: space-between;
                padding: 3px 5px;
            }
            .info-box {
                padding: 10px;
                display: flex;
                flex-flow: wrap;
                justify-content: space-between;
                .api-info-content {
                    // flex: 1;
                    min-width: 350px;
                    font-size: 12px;
                    // background-color: #fff;
                    box-shadow: 0 0 5px #000;
                    margin-left: 10px;
                    margin-bottom: 20px;
                    .api-info-title {
                        background-color: #1e1e1e;
                        display: flex;
                        h4 {
                            padding: 0 5px;
                            display: flex;
                            align-items: center;
                        }
                        span {
                            font-size: 12px;
                            strong {
                                font-size: 16px;
                            }
                        }
                    }
                    .api-info-item {
                        display: flex;
                        padding: 3px 5px;
                        .item-col {
                            // flex: 1;
                            text-align: left;
                            margin-right: 10px;
                        }
                        .progress-content {
                            min-width: 190px;
                        }
                        .item-col:first-child {
                            text-align: left;
                        }
                    }
                }
            }
            .info-static-total {
                display: flex;
                margin-top: 10px;
                padding: 5px 10px;
                background-color: #1e1e1e;
                span {
                    // flex: 1;
                    margin-left: 20px;
                }
            }
        }
    }
}
</style>